import { store } from "@store";
import { ConfirmDialogOptions } from "@containers/ConfirmDialog/ConfirmDialogOptions";
import { OptionsBuilder } from "@containers/ConfirmDialog/ConfirmDialogStore";

export function useConfirmDialog(options?: ConfirmDialogOptions<any>) {
  const confirm = <T>(opts?: ConfirmDialogOptions<T> | OptionsBuilder<T>) => {
    const o = opts || options;

    if (!o) {
      throw new Error("No options provided");
    }

    return store().ui.confirmDialog.confirm(o);
  };

  return { confirm };
}
